/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Projection_HeadingInputs */

const en_onboarding_v1_projection_heading = /** @type {(inputs: Onboarding_V1_Projection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your money goes further on Glider`)
};

const de_onboarding_v1_projection_heading = /** @type {(inputs: Onboarding_V1_Projection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Glider kommt Ihr Geld weiter`)
};

const pt_br2_onboarding_v1_projection_heading = /** @type {(inputs: Onboarding_V1_Projection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu dinheiro rende mais com a Glider`)
};

const tr_onboarding_v1_projection_heading = /** @type {(inputs: Onboarding_V1_Projection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paranız Glider ile daha ileri gider`)
};

const zh_cn2_onboarding_v1_projection_heading = /** @type {(inputs: Onboarding_V1_Projection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的资金在 Glider 上增长更多`)
};

const zh_hk2_onboarding_v1_projection_heading = /** @type {(inputs: Onboarding_V1_Projection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的資金在 Glider 增長更多`)
};

const ko_kr2_onboarding_v1_projection_heading = /** @type {(inputs: Onboarding_V1_Projection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider에서는 자금이 더 크게 성장해요`)
};

const ru_ru2_onboarding_v1_projection_heading = /** @type {(inputs: Onboarding_V1_Projection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С Glider ваши деньги растут быстрее`)
};

const es_419_onboarding_v1_projection_heading = /** @type {(inputs: Onboarding_V1_Projection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu dinero llega más lejos con Glider`)
};

/**
* | output |
* | --- |
* | "Your money goes further on Glider" |
*
* @param {Onboarding_V1_Projection_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_projection_heading = /** @type {((inputs?: Onboarding_V1_Projection_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Projection_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_projection_heading(inputs)
	if (locale === "de") return de_onboarding_v1_projection_heading(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_projection_heading(inputs)
	if (locale === "tr") return tr_onboarding_v1_projection_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_projection_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_projection_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_projection_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_projection_heading(inputs)
	return es_419_onboarding_v1_projection_heading(inputs)
});